type RuntimeEnv = Record<string, string | undefined>;

const getProcessEnv = (): RuntimeEnv => {
  const runtimeProcess = (globalThis as unknown as { process?: { env?: RuntimeEnv } }).process;
  return runtimeProcess?.env ?? {};
};

const getWindowEnv = (): RuntimeEnv => {
  if (typeof window === 'undefined') {
    return {};
  }
  const scoped = window as unknown as { __CURIOUS_ENV__?: RuntimeEnv };
  return scoped.__CURIOUS_ENV__ ?? {};
};

export const readEnv = (key: string, fallback = ''): string => {
  const processValue = getProcessEnv()[key];
  if (typeof processValue === 'string' && processValue.length > 0) {
    return processValue;
  }

  const windowValue = getWindowEnv()[key];
  if (typeof windowValue === 'string' && windowValue.length > 0) {
    return windowValue;
  }

  return fallback;
};

export default readEnv;
